import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { LoadupRequestSection } from "../components/LoadupRequestSection";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.LoadupRequestConfirmationDocumentTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <LoadupRequestSection id="loadup-request-confirmation">
                <p>{t`Thank you for submitting a Mattress Pickup Request Form!`}</p>
                <p>{t`Please allow 1-3 business days for our pickup partners to email you for scheduling.`}</p>
            </LoadupRequestSection>
        </PageSkeleton>
    );
};
